import { fetchActiveSubscriptionIfNeeded } from '@lootboy/lib/actions/SubscriptionActions';
import useFetchSelector from '@lootboy/lib/hooks/useFetchSelector';

import NewView from '~/components/SubscriptionOverview/NewView';
import OldView from '~/components/SubscriptionOverview/OldView';

import { subscriptionSelector } from '~/redux/selectors';

export default function SubscriptionOverview({ ...props }) {
  const {
    subscription: { version },
  } = useFetchSelector(fetchActiveSubscriptionIfNeeded, subscriptionSelector);

  if (!version) {
    return <OldView {...props} />;
  }

  return <NewView {...props} />;
}
